import axiosInstance from "../../interceptor/axiosInstance";
import {TUTORS} from "../../routes/routeConstants/apiRoutes";
import {deserialize} from "serializr";
import {PaginationModel} from "../../models/PaginationModel/pagination.model";
import {TutorModel} from "../../models/TutorModel/tutor.model";
import Notification from "../../shared/components/Notification";
import {NotificationTypes} from "../../enums/notificationTypes";
import { InstituteTutorModel } from "../../models/InstituteModel/tutor.model";

export default class TutorService{
    static getTutorsList(
        queryParams: String,
        onSuccess:Function,
        onError:Function,
        onFinal:() => void,
    ){
        return axiosInstance
            .get(TUTORS+queryParams)
            .then(response => {
                const tutors = deserialize(InstituteTutorModel, response.data["tutors"]);
                const pageMeta = deserialize(PaginationModel,response.data['meta']);
                onSuccess(tutors,pageMeta);
            })
            .catch(error => {
                onError(error);
            })
            .finally(onFinal)
    }

    static getTutorDetails(
        id: String,
        onSuccess:Function,
        onError:Function,
        onFinal:() => void,
    ){
        return axiosInstance
            .get(TUTORS+`/${id}`)
            .then(response => {
                const tutor = deserialize(TutorModel, response.data["tutor"]);
                onSuccess(tutor);
            })
            .catch(error => {
                onError(error);
            })
            .finally(onFinal)
    }

    static createTutor(
        data: any,
        onSuccess:Function,
        onError:Function,
        onFinal:() => void,
    ){
        return axiosInstance
            .post(TUTORS,data)
            .then(response => {
                const tutor = deserialize(TutorModel, response.data["tutor"]);
                onSuccess(tutor);
            })
            .catch(error => {
                onError(error);
                Notification({ message: "Error", description: "Unable to create the tutor",type: NotificationTypes.ERROR });
            })
            .finally(onFinal)
    }

    static updateTutor(
        id:string,
        data: any,
        onSuccess:Function,
        onError:Function,
        onFinal:() => void,
    ){
        return axiosInstance
            .put(TUTORS+`/${id}`,data)
            .then(response => {
                const tutor = deserialize(TutorModel, response.data["tutor"]);
                onSuccess(tutor);
            })
            .catch(error => {
                onError(error);
                Notification({ message: "Error", description: "Unable to update the tutor",type: NotificationTypes.ERROR });
            })
            .finally(onFinal)
    }

    static deleteTutor(
        id: string,
        onSuccess:Function,
        onError:Function,
        onFinal:() => void,
    ){
        return axiosInstance
            .delete(TUTORS+`/${id}`)
            .then(() => {
                onSuccess();
            })
            .catch(error => {
                Notification({ message: "Error", description: "Unable to delete the tutor",type: NotificationTypes.ERROR });
                onError(error);
            })
            .finally(onFinal)
    }
}
